import axios from 'axios';
const AUTH_USER_DATA = "auth-token";
const DEFAULT_USER_ATAG = "default-atag";
const CURRENT_USER_ATAG = "current-atag";
const AUTH_LOCAL_STORAGE_DETAIL_OPERATOR_DATA_KEY = 'detail-operator-data';
const AUTH_LOCAL_STORAGE_OPERATOR_KEY = 'default-operator-data';
const LOCAL_STORAGE_DEFAULT_LANG = 'default-language';
export interface OperatorInfo {
    company_name: string;
    brand: string;
    country: string;
    languages: [string];
    language: string;
    website_url: string;
    currency: string;
}
export const setCurrentAtagLocal = (atag: string): void => {
    localStorage.setItem(CURRENT_USER_ATAG, JSON.stringify(atag));
}
export const getCurrentAtagLocal= () => {
    try {
        return JSON.parse(localStorage.getItem(CURRENT_USER_ATAG) || "null");
    } catch {
        return null;
    }
}
export const setDefaultAtag = (atag: string): void => {
    localStorage.setItem(DEFAULT_USER_ATAG, JSON.stringify(atag));
}
export const getDefaultAtag= () => {
    try {
        return JSON.parse(localStorage.getItem(DEFAULT_USER_ATAG) || "null");
    } catch {
        return null;
    }
}
export const getDefaultLang = () => {
    try {
        return JSON.parse(localStorage.getItem(LOCAL_STORAGE_DEFAULT_LANG) || "null");
    } catch {
        return null;
    }
};
export const setDefaultLang = (lang: string) => {
    localStorage.setItem(LOCAL_STORAGE_DEFAULT_LANG, JSON.stringify(lang));
};
export const getUserAuthData = () => {
    try {
        return JSON.parse(localStorage.getItem(AUTH_USER_DATA) || "null");
    } catch {
        return null;
    }
};
export const setUserAuth = (token: any) => {
    localStorage.setItem(AUTH_USER_DATA, JSON.stringify(token));
};
export const removeUserAuth = (): void => {
    localStorage.removeItem(AUTH_USER_DATA);
    localStorage.removeItem(AUTH_LOCAL_STORAGE_OPERATOR_KEY)
    localStorage.removeItem(AUTH_LOCAL_STORAGE_DETAIL_OPERATOR_DATA_KEY)
    localStorage.removeItem(LOCAL_STORAGE_DEFAULT_LANG)
    localStorage.removeItem(DEFAULT_USER_ATAG)
    localStorage.removeItem(CURRENT_USER_ATAG)

};
export const isUserAuthenticated = (): boolean => {
    const authData = getUserAuthData();
    return !!authData;
};
export const setStorageCurrentOperator = (currentOperator: string) => {
    const lsValue = JSON.stringify(currentOperator);
    if (typeof localStorage !== 'undefined') {
        localStorage.setItem(AUTH_LOCAL_STORAGE_OPERATOR_KEY, lsValue);
    }

    return getCompanyInfo(currentOperator);
};

export const getStoragedCurrentOperator = () => {
    if (!localStorage) {
        return
    }

    const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_OPERATOR_KEY)
    if (!lsValue) {
        return
    }

    try {
        const operator = JSON.parse(lsValue) as string
        if (operator) {
            // You can easily check auth_token expiration also
            return operator
        }
    } catch (error) {
        console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
    }
}

export const getCompanyInfo = async (operatorName: string): Promise<void> => {
    let defaultLanguage = getDefaultLang();
    setDefaultAtag(operatorName + 'Atag');
    try {
        const response = await axios.get<OperatorInfo>(`/api/operators/${operatorName}/info`);
        const data = {
            company_name: response.data.company_name,
            website_url: response.data.website_url,
            currency: response.data.currency,
            brand: response.data.brand,
            country: response.data.country,
            languages: response.data.languages,
            language: response.data.language,
        };
        const lsValue = JSON.stringify(data);
        if (!defaultLanguage) {
            setDefaultLang(response.data.language);
        }
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem(AUTH_LOCAL_STORAGE_DETAIL_OPERATOR_DATA_KEY, lsValue);
        }
    } catch (error) {
        console.error('Error while fetching operator info:', error);
        throw error;
    }
};

export const removeOperatorInfo = () => {
    if (!localStorage) {
        return
    }

    localStorage.removeItem(AUTH_LOCAL_STORAGE_DETAIL_OPERATOR_DATA_KEY);

}
export const getStoragedOperatorInfo = () => {
    if (!localStorage) {
        return;
    }

    const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_DETAIL_OPERATOR_DATA_KEY);
    if (!lsValue) {
        return;
    }

    try {
        const operator = JSON.parse(lsValue) as OperatorInfo;
        if (operator) {
            return operator;
        }
    } catch (error) {
        console.error('AUTH LOCAL STORAGE PARSE ERROR', error);
    }
};
